export default __webpack_public_path__ + "assets/b9ecc1b8ffef1e97cb04b3faaf3cc1c6/12.jpg";